import { styled } from '@/stitches.config';
import { Box, Button } from '@base-app';

export const StyledConsentTrendContainer = styled(Box, {
  height: '100%',
  width: '100%',
});

export const StyledButton = styled(Button, {
  width: '130px',
});

export const StyledButtonContainer = styled(Box, {
  display: 'flex',
  justifyContent: 'center',
  margin: '$4 0 $6 0',
});
